export default __webpack_public_path__ + "3c19ac505ae442b39e341b1650c6d1c2.png";